/**
 * @file        src/api/groupRequests.js
 * @description Group Booking Requests API calls (/api/group-requests) — the
 *              storefront's "Flight Request" quote form, written by
 *              booking_backend (migration 073). Read-mostly: the only writes
 *              are the pipeline status + internal note the team records while
 *              working the lead, and deleting a spam row.
 *
 *              ONE REQUEST CARRIES BOTH THE ROWS AND THE COUNTS. The list
 *              endpoint returns its KPI totals in `meta.totals`, computed from
 *              the SAME filtered query — so a card cannot count a different set
 *              from the table beneath it even by accident, which is the failure
 *              a separate /totals call has to be kept in step to avoid (§9d).
 * @author      Kinetika Labs
 * @created     2026-09-25
 * @changelog
 *   - 2026-09-25 Claude — Initial (Query Management → Group Booking Requests).
 */
import { get, patch, del } from './client';

/**
 * Paginated + filterable list.
 * params: { page, pageSize, brand, status, tripType, customerType, notified,
 *           search, from, to }.
 * Response shape: { data: [rows], meta: { page, pageSize, total, totals } }.
 */
export const listGroupRequests = (params) => get('/group-requests', { params });

/** One request in full (the list already returns every field; this is for deep links). */
export const getGroupRequest = (id) => get(`/group-requests/${id}`);

/**
 * Move the lead along. `status` is one of
 * new | in_progress | quoted | won | lost; an empty `note` clears the note,
 * an omitted one leaves it.
 */
export const setGroupRequestStatus = (id, body) => patch(`/group-requests/${id}`, body);

/** Remove a spam or duplicate submission. */
export const deleteGroupRequest = (id) => del(`/group-requests/${id}`);
